import AccountOpening from '@advisor/models/store/apexAccountOpening/index';
import RwApexService from '@advisor/rwSdk/ApexClientAccountOpeningService';
import CustodianService from '@advisor/rwSdk/CustodianService';
import ClientService from '@advisor/rwSdk/ClientService';
import CloudConvertServices from '@advisor/rwSdk/CloudConvertService';
import {addRiaComponentTo} from '@advisor/util/store/paramInjects';
import exceptionHandler from '@advisor/util/exceptionHandler';
import {uploadDocumentFlag} from '@advisor/remote-config';
import {mapDocumentResponse} from '@advisor/util/documentResponseMapper';

const stateObj = function () {
  return new AccountOpening();
};

const getters = {
  getDndbwEquifaxResults(state) {
    return state.equifaxResult.dndbResult;
  },
  getCriticalAlertsEquifaxResults(state) {
    return state.equifaxResult.dowJonesResult;
  },
  getCriticalAlertsEquifaxComments(state) {
    return state.equifaxResult.criticalAlertsComments;
  },
  getDNDBWEquifaxComments(state) {
    return state.equifaxResult.dndbwComments;
  },
};

const actions = {
  async getAccountRequestsStatusCount({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.getApexAccountRequestsCount(fullPayload).catch((error) => {
        throw error;
      });
      const {activeRequestsCount, completedRequestsCount, rejectedRequestsCount} = sdkResponse;
      const tabsCount = {
        'Active Requests': activeRequestsCount,
        Completed: completedRequestsCount,
        Rejected: rejectedRequestsCount,
      };

      commit('SET_ACCOUNT_REQUESTS_STATUS_COUNT', tabsCount);

      return Promise.resolve(tabsCount);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.getAccountRequestsStatusCount', error);

      return Promise.reject(error);
    }
  },
  async getAccountOpeningList({commit, rootState}, payload) {
    try {
      const {riaId} = rootState;
      const fullPayload = addRiaComponentTo({...payload, riaId}, rootState.settings.default);

      const sdkResponse = await RwApexService.getAccountRequestForAdvisor(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_ACCOUNT_OPENING_LIST_DATA', sdkResponse.data);

      commit('SET_ACCOUNT_OPENING_TOTAL_COUNT', sdkResponse.count);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.getAccountOpeningList', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getAccountOpeningListForExport({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.getAccountRequestForAdvisor(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse.data);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.getAccountOpeningListForExport', error);

      return Promise.reject(error);
    }
  },

  async getApexAccountRequestByRequestId({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.getApexAccountRequest(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_SELECTED_ACCOUNT', sdkResponse.data);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.getApexAccountRequestByRequestId', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async addInvestigationHistoryResendEmail({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.addApexAccountInvestigationHistory(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.addInvestigationHistoryResendEmail', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async putKycStatus({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await CustodianService.putKycStatus(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.putKycStatus', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getClientProfile({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await ClientService.getClientProfile(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.getClientProfile', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async cancelAccountRequestHeader({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await CustodianService.cancelAccountRequestHeader(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.cancelAccountRequestHeader', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateKycDocumentStatus({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.updateKycDocumentStatus(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.updateKycDocumentStatus', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getAccountRequestAccountNumbersForAdvisor({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.getAccountRequestAccountNumbersForAdvisor(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_ACCOUNT_NUMBERS_DROPDOWN_LIST', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.getAccountRequestAccountNumbersForAdvisor', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getAccountRequestClientList({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.getAccountRequestClientList(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_CLIENTS_DROPDOWN_LIST', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.getAccountRequestClientList', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getAccountInvestigationByAccountId({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      let sdkResponse = await RwApexService.getAccountInvestigationByAccountId(fullPayload).catch((error) => {
        throw error;
      });

      if (sdkResponse?.id) {
        sdkResponse.result = sdkResponse.investigationResult;
        sdkResponse.result.dowJonesResult = sdkResponse.investigationResult?.sanctionsAndNews;
      } else {
        sdkResponse = {
          result: {
            dndbResult: {profiles: []},
            dowJonesResult: {profiles: []},
          },
          criticalAlertsComments: '',
          identityVerificationComments: '',
          dndbwComments: '',
        };
      }

      commit('STORE_EQUIFAX_RESULT_CRITICAL_ALERTS', sdkResponse);
      commit('STORE_EQUIFAX_RESULT_DNDBW', sdkResponse);
      commit('STORE_EQUIFAX_RESULT_COMMENTS', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.getAccountInvestigationByAccountId', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getAccountRequestRejectReasons({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.getAccountRequestRejectReasons(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_REASONS_DROPDOWN_LIST', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.getAccountRequestRejectReasons', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async downloadDocumentByDocId({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await ClientService.downloadDocumentByDocId(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.downloadDocumentByDocId', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getApexAccountRequest({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.getApexAccountRequest(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.getApexAccountRequest', error);

      return Promise.reject(error);
    }
  },
  storeUploadedDocuments(context, payload) {
    context.commit('STORE_UPLOADED_DOCUMENTS', payload);
  },

  resetUploadedDocuments(context) {
    context.commit('RESET_UPLOADED_DOCUMENTS');
  },

  storeComments(context, payload) {
    context.commit('STORE_COMMENTS', payload);
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async imageUploadForKYC({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.imageUploadForKYCprocess(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.imageUploadForKYC', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async uploadClientDocument({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);
      const flag = await uploadDocumentFlag();
      // depending on feature flag status, the respective service will be called

      if (flag) {
        // eslint-disable-next-line no-useless-catch
        try {
          const sdkResponse = await CloudConvertServices.scanAndUploadDocument(fullPayload);

          if (!sdkResponse || !sdkResponse.fileInfo.docId) {
            throw new Error('No sdk response.');
          }

          const mappedResponse = await mapDocumentResponse(sdkResponse.fileInfo);

          return Promise.resolve(mappedResponse);
        } catch (error) {
          throw error;
        }
      }

      const sdkResponse = await ClientService.uploadDocumentByBase64(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.uploadClientDocument', error);
      throw error;
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async linkKycDocument({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.linkKycDocument(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.linkKycDocument', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateAccountInvestigationCommentByAccountId({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.updateAccountInvestigationCommentByAccountId(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.updateAccountInvestigationCommentByAccountId', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateAccountInvestigationOnApex({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.updateAccountInvestigationOnApex(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.updateAccountInvestigationOnApex', error);

      return Promise.reject(error);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateRejectAccountInvestigationStatusOnApex({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwApexService.updateRejectAccountInvestigationStatusOnApex(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('apexAccountOpening.updateRejectAccountInvestigationStatusOnApex', error);

      return Promise.reject(error);
    }
  },
};

const mutations = {
  SET_ACCOUNT_REQUESTS_STATUS_COUNT(state, payload) {
    state.statusCount = payload;
  },
  SET_ACCOUNT_OPENING_LIST_DATA(state, payload) {
    state.accountOpeningListData = payload;
  },
  SET_ACCOUNT_OPENING_TOTAL_COUNT(state, payload) {
    state.totalCount = payload;
  },
  SET_SELECTED_ACCOUNT(state, payload) {
    state.selectedAccount = payload;
  },
  STORE_EQUIFAX_RESULT_CRITICAL_ALERTS(state, data) {
    const {
      result: {
        dowJonesResult: {profiles = []},
      },
    } = data;

    state.equifaxResult.dowJonesResult = profiles;
  },
  STORE_EQUIFAX_RESULT_DNDBW(state, data) {
    const {
      result: {
        dndbResult: {profiles = []},
      },
    } = data;

    state.equifaxResult.dndbResult = profiles;
  },

  STORE_EQUIFAX_RESULT_COMMENTS(state, data) {
    state.equifaxResult.identityVerificationComments = data.identityVerificationComments;
    state.equifaxResult.criticalAlertsComments = data.criticalAlertsComments;
    state.equifaxResult.dndbwComments = data.dndbwComments;
  },
  STORE_UPLOADED_DOCUMENTS(state, data) {
    // eslint-disable-next-line default-case
    switch (data.type) {
      case 'ssn': {
        state.documents.ssn = data.file;
        break;
      }
      case 'dl': {
        state.documents.dl = data.file;
        break;
      }
      case 'criticalAlerts': {
        state.documents.criticalAlerts = data.file;
        break;
      }
      case 'dndbw': {
        state.documents.dndbw = data.file;
        break;
      }
    }
  },
  RESET_UPLOADED_DOCUMENTS(state) {
    state.documents = {ssn: {}, dl: {}, criticalAlerts: {}, dndbw: {}};
    state.criticalAlertsComments = '';
    state.dndbwComments = '';
  },
  STORE_COMMENTS(state, data) {
    // eslint-disable-next-line default-case
    switch (data.type) {
      case 'criticalAlerts': {
        state.criticalAlertsComments = data.comments;
        break;
      }
      case 'dndbw': {
        state.dndbwComments = data.comments;
        break;
      }
    }
  },

  SET_ACCOUNT_NUMBERS_DROPDOWN_LIST(state, data) {
    state.accountNumbersDropdownList = data;
  },

  SET_CLIENTS_DROPDOWN_LIST(state, data) {
    state.clientsDropdownList = data;
  },

  SET_REASONS_DROPDOWN_LIST(state, data) {
    state.reasonsDropdownList = data;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  actions,
  getters,
  mutations,
};
